import { render, staticRenderFns } from "./TranslateModal.vue?vue&type=template&id=4933b2e2&"
import script from "./TranslateModal.vue?vue&type=script&lang=js&"
export * from "./TranslateModal.vue?vue&type=script&lang=js&"
import style0 from "./TranslateModal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VMenu } from 'vuetify/lib/components/VMenu';
installComponents(component, {VBtn,VMenu})
